import { gql } from '@apollo/client';

// QUERY USER DETAIL
export const USER_DETAIL = gql`
    query me {
        me {
            id
            creator
            created
            updater
            updated
            phone
            firstName
            lastName
            userName
            email
            bio
            userType
            approved
            gender
            currency
            quizCompleted
            profileImageUrl
            modelImageUrl
            stylistExpertiseId
            preferredLanguage
            stylistExpertise {
                id
                title
                value
            }
            stores {
                id
                taffiId
                name
                url
                logoImageUrl
                platform
            }
            isReviewer
            bodyFullFrontImage
        }
    }
`;
export const ME = gql`
    query me {
        me {
            id
            phone
            firstName
            lastName
            userName
            email
            bio
            userType
            approved
            gender
            profileImageUrl
            modelImageUrl
            stylistExpertiseId
            stylistExpertise {
                id
                title
                value
            }
            bodyFullFrontImage
        }
    }
`;
